import '~/js/libs/jquery-ui.selectmenu.min';
import 'slick-carousel';
import popovers from '~/js/modules/popovers';
import BookingPopup from '~/js/components/global/BookingPopup';

popovers();

const beachesResorts = window.beaches_app.page.resorts;


const $sliderBooking = $('.js-slick-slider-booking');

$sliderBooking.slick({
  mobileFirst: true,
  variableWidth: true,
  arrows: false,
  dots: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  speed: 500,
  cssEase: 'ease-out',
  pauseOnFocus: false,
  pauseOnHover: false,
  responsive: [{
    breakpoint: 767,
    settings: {
      dots: true,
      slidesToShow: 2,
      slidesToScroll: 2
    }
  }, {
    breakpoint: 1199,
    settings: {
      dots: false,
      slidesToShow: 5,
      slidesToScroll: 4
    }
  }]
});

$(document).on('click', '[data-category]', function chooseCategory() {
  const modeIndex = $(this).data('category');

  ReactDOM.render(
    <BookingPopup
      resorts={ beachesResorts }
      schedulerModeIndex={modeIndex}
    />,
    document.getElementById('booking-component')
  );
});


$(document).on('click', (e) => {
  if ((e.target.classList.contains('mfp-close')) || (e.target.classList.contains('mfp-container'))) {
    ReactDOM.unmountComponentAtNode(document.getElementById('booking-component'));
  }
});
